import React from "react";
import {
    XBrowseProps,
    XLazyColumn,
    XLazyDataTable,
} from "@michalrakus/x-react-web-lib/XLazyDataTable";
import {UpozorneniePreObdobieForm} from "./UpozorneniePreObdobieForm";

export const UpozorneniePreObdobieBrowse = (props: XBrowseProps) => {

    const onAddRow = () => {
        // openForm pridavame automaticky v XFormNavigator3 pri renderovani komponentu
        props.openForm!(<UpozorneniePreObdobieForm/>);
    }

    const onEdit = (selectedRow: any) => {
        // openForm pridavame automaticky v XFormNavigator3 pri renderovani komponentu
        props.openForm!(<UpozorneniePreObdobieForm id={selectedRow.id}/>);
    }

    return (
        <XLazyDataTable entity="UpozorneniePreObdobie" label="Upozornenia" sortField="id" rows={30}
                        onAddRow={onAddRow} onEdit={onEdit} removeRow={true}
                        displayed={props.displayed}>
            <XLazyColumn field="id" header="ID" width="5rem"/>
            <XLazyColumn field="zapnute" header="Zapnuté"/>
            <XLazyColumn field="datumOd" header="Dátum od"/>
            <XLazyColumn field="datumDo" header="Dátum do"/>
            <XLazyColumn field="upozornenie" header="Upozornenie" width="50rem"/>
        </XLazyDataTable>
    );
}
